import {SeoMetadata} from "@next/utils"

export function updateDocumentSeoMetadata(seoMetadata: SeoMetadata) {
    const metaTitle = document.querySelector("title")
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    const metaDescription = document.querySelector('meta[name="description"]')
    const metaRobots = document.querySelector('meta[name="robots"]')

    metaKeywords?.setAttribute("content", seoMetadata.keywords)
    metaDescription?.setAttribute("content", seoMetadata.description)
    metaRobots?.setAttribute("content", seoMetadata.robots)

    if (metaTitle?.innerHTML) {
        metaTitle.innerHTML = seoMetadata.title
    }

    if (seoMetadata.canonical) {
        const metaCanonical = document.querySelector("link[rel='canonical']")
        metaCanonical?.setAttribute("href", seoMetadata.canonical)
    }

    if (seoMetadata.robots === "noindex, nofollow") document.querySelector("link[rel='canonical']")?.remove()
}
